import React, { useState } from 'react';
import { Modal, ErrorHandler, LoadingState } from '@common/components';
import { Select, Form } from 'antd';
import { useQuery } from '@common/hooks';
import {
  WORKFORCE_GROUP_FLAT_QUERY,
  WorkforceGroupFlatType,
} from '@scheduling/graphql';

type Props = {
  visible: boolean;
  selectedCount: number;
  currentGroupId: string;
  loading: boolean;
  onConfirm: (workforceGroupId: string) => void;
  onCancel: () => void;
};

export function MoveConfirmationModal({
  visible,
  selectedCount,
  currentGroupId,
  loading,
  onConfirm,
  onCancel,
}: Props) {
  const [form] = Form.useForm();
  const [selectedGroupId, setSelectedGroupId] = useState<string>('');

  const {
    loading: groupsLoading,
    error: groupsError,
    data: groupsData,
  } = useQuery(WORKFORCE_GROUP_FLAT_QUERY);

  if (groupsLoading) {
    return (
      <Modal
        title="Group Move"
        open={visible}
        onCancel={onCancel}
        footer={null}
      >
        <LoadingState />
      </Modal>
    );
  }

  if (groupsError) {
    return (
      <ErrorHandler
        error={groupsError}
        log="MoveConfirmationModal"
        messageType="contextual"
      />
    );
  }

  const availableGroups =
    groupsData?.workforceGroups?.filter(
      (workforceGroup: WorkforceGroupFlatType) =>
        workforceGroup.id !== currentGroupId
    ) || [];

  const handleConfirm = () => {
    if (selectedGroupId) {
      onConfirm(selectedGroupId);
    }
  };

  return (
    <Modal
      title={`Move ${selectedCount} selected staff to:`}
      open={visible}
      onCancel={onCancel}
      okText="Move Staff"
      onOk={handleConfirm}
      confirmLoading={loading}
      okButtonProps={{ disabled: !selectedGroupId }}
    >
      <Form form={form} layout="vertical">
        <Form.Item label="Group" required>
          <Select
            placeholder="Group"
            value={selectedGroupId}
            onChange={setSelectedGroupId}
            style={{ width: '100%' }}
          >
            {availableGroups.map((group: WorkforceGroupFlatType) => (
              <Select.Option key={group.id} value={group.id}>
                {group.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
}
